<select class=" btn-light form-control dropdown-toggle btn-block input-btn"
[(ngModel)]="selectValue"
(ngModelChange)="select('',selectValue, $event)">
    <option  value="" *ngIf="placeholder" selected disabled>{{placeholder}}</option> 
    <option *ngFor="let opt of options" [disabled]="getOptionDisabled(opt.value)"  [value]="opt.value">{{opt.label}}</option>
</select>